module.exports = __webpack_public_path__ + "static/media/3040164000_03.42a4e21f.jpg";